import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/calendar.svg'
import _imports_1 from '../../assets/images/Location.svg'


const _withScopeId = n => (_pushScopeId("data-v-7c4c7902"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center justify-center" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "custom-gradient text-center text-2xl not-italic font-semibold md:pb-2 sm:pb-2 md:mb-2 sm:mb-2 sm:text-base"
}
const _hoisted_4 = { class: "containerPaymentText flex justify-between" }
const _hoisted_5 = { class: "flex items-center mr-2" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "mr-2",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_7 = { class: "sm:text-xs" }
const _hoisted_8 = { class: "playerSubtitle sm:text-xs" }
const _hoisted_9 = { class: "containerPaymentText flex justify-between" }
const _hoisted_10 = { class: "flex items-center mr-2" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "mr-2",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_12 = { class: "sm:text-xs" }
const _hoisted_13 = { class: "flex" }
const _hoisted_14 = { class: "sm:text-xs" }
const _hoisted_15 = { class: "containerPaymentText flex justify-between" }
const _hoisted_16 = { class: "flex items-center mr-2" }
const _hoisted_17 = { class: "flex items-center" }
const _hoisted_18 = { class: "mr-2" }
const _hoisted_19 = { class: "sm:text-xs" }
const _hoisted_20 = { class: "playerSubtitle sm:text-xs" }
const _hoisted_21 = {
  key: 1,
  class: "containerPaymentText flex justify-between"
}
const _hoisted_22 = { class: "flex items-baseline" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "mr-2",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_24 = { class: "sm:text-xs" }
const _hoisted_25 = {
  key: 0,
  class: "tooltip"
}
const _hoisted_26 = { class: "relative mb-2 cursor-pointer" }
const _hoisted_27 = ["placeholder"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_SvgContainer = _resolveComponent("SvgContainer")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.showImage)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "mb-6 sm:hidden image",
            src: _ctx.imageUrl,
            alt: ""
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true)
    ]),
    (_ctx.parentName == 'checkoutView')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("booking_details")), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("date_colon")), 1)
      ]),
      _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.getDateStr()), 1)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t("location_colon")), 1)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_router_link, {
          to: "#",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToMaps())),
          class: "text-blue-500"
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.capitalizeFirstLetter(_ctx.activity.tenant.name)), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_SvgContainer, { name: "dollarIcon" })
          ])
        ]),
        _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.$t("total_amount_colon")), 1)
      ]),
      _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.activity.amount.amountStr), 1)
    ]),
    (_ctx.showShare)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.$t("share_with_friends")), 1)
          ]),
          (!_ctx.isDeviceVeryOld())
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("input", {
                    readonly: "",
                    class: "relative lastInput w-full items-center pr-4",
                    type: "text",
                    placeholder: _ctx.getBookingUrl(_ctx.activity.id),
                    id: "bookingUrl",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.copyToClipBoard()))
                  }, null, 8, _hoisted_27),
                  _createElementVNode("div", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.copyToClipBoard())),
                    class: "inputImage"
                  }, [
                    _createVNode(_component_SvgContainer, { name: "copyIcon" })
                  ])
                ]),
                _createElementVNode("span", {
                  class: _normalizeClass(["tooltiptext-hidden", { tooltiptext: _ctx.copied }])
                }, _toDisplayString(_ctx.$t("copied_exclamation")), 3)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}